import { Box, Button } from "@mui/material";
import React from "react";

const WidgetBar = ({onBackClick}:{onBackClick: Function}) => {
    return (
        <Box display="flex" height={50}><Button onClick={() =>{onBackClick()}}>Back</Button></Box>
    )
}

export default WidgetBar;